<ng-container *ngIf="variant === 'vertical-style-1'">
  <navbar-vertical-style-1></navbar-vertical-style-1>
</ng-container>
